export default "__VITE_ASSET__Dyrmmgww__"